<template>
  <div>
    <div class="col-12 lang">
      <h5>{{ traduccion.idioma.idioma }}</h5>

      <div class="row">
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('app.modules.product_family.addEdit.headers.description') }}</label>
            <el-input
              type="textarea"
              :rows="5"
              :placeholder="$t('app.modules.product_family.addEdit.headers.description')"
              v-model="traduccion.descripcion">
            </el-input>
            <div class="text-danger invalid-feedback"> {{ $t('app.validation.required') }} </div>
          </div>
        </div>
      </div>

      <div class="separate"></div>

      <div class="row">
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('app.modules.product_family.addEdit.headers.technical_sheet') }}</label>

            <el-upload
              class="upload-demo"
              action="#"
              accept="application/pdf"
              :file-list="fileTs"
              :limit="1"
              :on-preview="handlePreview"
              :on-change="handleChangeTSheet"
              :on-remove="handleRemoveTSheet"
              :auto-upload="false"
            >
              <n-button
                slot="trigger"
                size="small"
                type="primary"
              >{{ $t("app.upload.select_file") }}</n-button
              >
              <div class="el-upload__tip" slot="tip">
                {{ $t("app.upload.pdf") }}
              </div>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="separate"></div>

      <div class="row">
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('app.modules.product_family.addEdit.headers.safety_sheet') }}</label>

            <el-upload
              class="upload-demo"
              action="#"
              accept="application/pdf"
              :file-list="fileSs"
              :limit="1"
              :on-preview="handlePreview"
              :on-change="handleChangeSSheet"
              :on-remove="handleRemoveSSheet"
              :auto-upload="false"
            >
              <n-button
                slot="trigger"
                size="small"
                type="primary"
              >{{ $t("app.upload.select_file") }}</n-button
              >
              <div class="el-upload__tip" slot="tip">
                {{ $t("app.upload.pdf") }}
              </div>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="separate"></div>

    </div>

  </div>
</template>

<script>
import Traduccion from "@/models/familiaProducto/FamiliaProductoTraduccion";

export default {
  props: {
    traduccion: {
      type: undefined,
      default: () => new Traduccion()
    }
  },
  data() {
    return {
      fileTs: [],
      fileSs: []
    }
  },
  created() {
    if(!!this.traduccion.hojaTecnica && this.traduccion.hojaTecnica.length > 0) this.fileTs.push({
      uid: this.traduccion.hojaTecnica ,
      name: this.$t('app.modules.product_family.addEdit.headers.technical_sheet'),
      url: this.traduccion.hojaTecnica
    });
    if(!!this.traduccion.hojaSeguridad && this.traduccion.hojaSeguridad.length > 0) this.fileSs.push({
      uid: this.traduccion.hojaSeguridad ,
      name: this.$t('app.modules.product_family.addEdit.headers.safety_sheet'),
      url: this.traduccion.hojaSeguridad
    });
  },
  methods: {
    handleRemoveTSheet(){ this.traduccion.hojaTecnica = null; },
    handleChangeTSheet(file){ this.traduccion.hojaTecnica = file.raw; },
    handleRemoveSSheet(){ this.traduccion.hojaSeguridad = null; },
    handleChangeSSheet(file){ this.traduccion.hojaSeguridad = file.raw; },
    handlePreview(file){ window.open(file.url, "_blank"); }
  }
}
</script>

<style scoped>
.separate {
  height: 1px;
  background: #f1f1f1;
  margin: 15px 0;
}
.lang {
  margin: 20px 0;
  padding: 10px;
  background: #fbfbfb;
}
.lang h5 {
  margin: 10px 0;
  font-weight: 600;
}
</style>
